import { render, staticRenderFns } from "./WysiwygAddon.vue?vue&type=template&id=0d50dd58"
import script from "./WysiwygAddon.vue?vue&type=script&lang=ts"
export * from "./WysiwygAddon.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports